!function($, window, document) {
    const $win = $(window), $doc = $(document), $header = $(".header"), players = $(".js-player");
    var $body = $("body");
    let resizeTimer;
    function headerHeight() {
        return $(".header").outerHeight();
    }
    function heroHeight() {
        return $(".hero").outerHeight();
    }
    function setHeaderHeightAsCssVariable() {
        $("body").css("--header-h", `${Math.floor(headerHeight())}px`);
    }
    function setWindowHeightAsCssVariable() {
        $("body").css("--win-h", `${$win.innerHeight()}px`), $("body").css("--container-w", `${$(".container").outerWidth()}px`);
    }
    function setHeroHeightAsCssVariable() {
        $("body").css("--hero-h", `${heroHeight()}px`);
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    };
    const isMobile = () => $(window).outerWidth() <= 768, togglePlayPauseInSlides = slides => {
        slides.each((function() {
            const $slide = $(this), $media = $slide.find(".media");
            $media.find(".plyr").length && $media[0].plyr && setTimeout((() => {
                const $currentMedia = $slide.find(".media");
                !0 === $currentMedia.data("autoplay") && $currentMedia[0].plyr.play(), !0 === $currentMedia.data("mute") ? $currentMedia[0].plyr.decreaseVolume(100) : $currentMedia[0].plyr.increaseVolume(100);
            }));
        }));
    }, radioButtonsStep = () => {
        const $radioContainers = $(".js-radio-container:not(.hidden)");
        let allRadiosChecked = !1, url_data = {};
        if (!$radioContainers.length) return;
        $radioContainers.each((function() {
            const $radioContainer = $(this), $radioInputs = $radioContainer.find("input"), hasCheckedRadioBtn = $radioInputs.is(":checked");
            $radioInputs.each((function() {
                const $input = $(this);
                $input.is(":checked") && (url_data[$input.attr("name")] = $input.val());
            })), $radioContainer.toggleClass("is-checked", hasCheckedRadioBtn), allRadiosChecked = hasCheckedRadioBtn;
        })), $radioContainers.closest(".js-room-radios").toggleClass("all-checked", allRadiosChecked);
        const $link = $radioContainers.closest(".js-room-radios").find(".js-search-submit");
        if ($link.length && allRadiosChecked) {
            const url = $link.attr("data-original-url") || $link.attr("href"), url_params = new URLSearchParams(url_data);
            $link.attr("href", url + "?" + url_params.toString()), $link.attr("data-original-url", url);
        }
    };
    $doc.on("change", 'input[name="room_type"]', (function() {
        const roomType = $(this).val(), $radioContainerWithOthers = $(".js-radio-container--with-others");
        "With others" === roomType ? $radioContainerWithOthers.removeClass("hidden") : $radioContainerWithOthers.addClass("hidden");
    })), $doc.on("mouseenter", ".grid--grow .grid__col", (function(e) {
        $(".grid__col").removeClass("is-active sibling-active");
    })), $doc.on("mousemove", (function(e) {
        $(e.target).closest(".grid__col").length && $(e.target).closest(".grid--grow").length && setTimeout((() => {
            $(e.target).closest(".grid__col").addClass("is-active").siblings().addClass("sibling-active");
        }));
    })), $doc.on("mouseleave", ".grid--grow .grid__col", (function(e) {
        $(".grid__col").removeClass("is-active"), $(".grid__col").siblings().removeClass("sibling-active");
    })), $doc.on("mouseleave", ".grid--grow", (function(e) {
        $(e.target).closest(".grid__col").addClass("is-active").siblings().removeClass("is-active").addClass("sibling-active");
    }));
    const setSliderContentHeight = $slider => {
        const $sliderContentContainer = $slider.closest("section").find(".js-slider-content").parent();
        $sliderContentContainer.length && setTimeout((() => {
            const activeSliderContentHeight = $slider.closest("section").find(".js-slider-content.is-active").outerHeight();
            0 != activeSliderContentHeight && $sliderContentContainer.closest("section").css("--slider-content-h", `${activeSliderContentHeight}px`);
        }), 100);
    }, $parallaxContainers = $(".js-parallax-content"), $window = $(window);
    function handleServiceContentHeight() {
        $(".tiles-info").each((function(index, el) {
            const $singleServices = $(el), $service = $singleServices.find(".grid__col");
            !function findIconHeightPerRow(servicesLength, service) {
                const rows = service.length / servicesLength;
                for (let i = 0; i < rows; i++) {
                    let arrOfHeights = [];
                    const servicesTrimed = service.splice(0, servicesLength);
                    for (let j = 0; j < servicesTrimed.length; j++) {
                        const $iconHeight = $(servicesTrimed[j]).find(".tile__image").outerHeight();
                        arrOfHeights.push($iconHeight);
                    }
                    for (let j = 0; j < servicesTrimed.length; j++) {
                        const $singleService = $(servicesTrimed[j]), maxHeight = Math.max(...arrOfHeights);
                        $singleService.css("--image-height", `${maxHeight}px`);
                    }
                }
            }(Math.round($singleServices.outerWidth() / $service.outerWidth()), $service);
        }));
    }
    function initElementParallax($parallaxContainers) {
        $parallaxContainers.each(((idx, parallaxContainer) => {
            ($parallaxContainer => {
                const windowScrollTop = $window.scrollTop(), parallaxContainerHeight = ($window.height(), 
                $parallaxContainer.outerHeight(!0)), progress = ($parallaxContainer.offset().top, 
                windowScrollTop / parallaxContainerHeight * parseInt($parallaxContainer.attr("data-speed")));
                $parallaxContainer[0].style.setProperty("--parallax-image-translate", `-${progress}%`);
            })($(parallaxContainer));
        }));
    }
    document.addEventListener("DOMContentLoaded", (function() {
        if (window.location.hash) {
            "scrollRestoration" in history && (history.scrollRestoration = "manual");
            const hash = window.location.hash;
            history.replaceState(null, null, window.location.pathname), setTimeout((() => {
                const element = document.querySelector(hash);
                element && ($("html, body").animate({
                    scrollTop: $(element).offset().top - $(".header").outerHeight()
                }), history.pushState(null, null, hash));
            }), 50);
        }
    }));
    const initSlider = (slider, options) => {
        const $slider = $(slider);
        $slider.each((function() {
            if (0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $sliderInitilizer = $currentSlider.find(".slider__slides");
                let $customArrows = $currentSlider.closest("section").find(".js-slider-arrows");
                $customArrows.length || ($customArrows = $currentSlider.closest(".popup").find(".js-slider-arrows")), 
                $sliderInitilizer.on("init", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("afterChange", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("breakpoint", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                    setSliderContentHeight($slider), (($slider, currenSlideIndex) => {
                        const $sliderContent = $slider.closest("section").find(".js-slider-content");
                        $sliderContent.length && $sliderContent.eq(currenSlideIndex).addClass("is-active").siblings().removeClass("is-active");
                    })($slider, nextSlide), slick.currentSlide >= slick.slideCount - slick.options.slidesToShow ? $(this).removeClass("is-last-slider") : $(this).addClass("is-last-slider");
                })), $sliderInitilizer.slick({
                    slidesToShow: 1,
                    draggable: !0,
                    slidesToScroll: 1,
                    arrows: !0,
                    autoplay: !1,
                    dots: !1,
                    appendArrows: $customArrows.length ? $customArrows : null,
                    ...options
                }), $currentSlider.find(".slick-slider").find(".slick-slide").length > $sliderInitilizer.slick("slickGetOption", "slidesToShow") && $currentSlider.closest("section").addClass("has-slider"), 
                setSliderContentHeight($slider);
            }
        }));
    };
    function adjustSelectWidth() {
        const $selects = $(".filters select");
        $selects.length && $selects.each((function() {
            const selectedOption = this.options[this.selectedIndex].text, tempSpan = document.createElement("span");
            tempSpan.style.visibility = "hidden", tempSpan.style.whiteSpace = "nowrap", tempSpan.style.font = window.getComputedStyle(this).font, 
            tempSpan.innerText = selectedOption, document.body.appendChild(tempSpan), this.style.width = `${tempSpan.offsetWidth + 30}px`, 
            document.body.removeChild(tempSpan);
        }));
    }
    const initMobileSliders = (slider, options) => {
        const $sliders = slider;
        $sliders.length && $($sliders).each((function() {
            if (isMobile() && 0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $customArrows = ($currentSlider.find(".slider__slides"), 
                $currentSlider.closest("section").find(".js-slider-arrows"));
                $(this).slick({
                    slidesToScroll: 1,
                    swipe: !0,
                    draggable: !0,
                    infinite: !1,
                    arrows: !0,
                    mobileFirst: !0,
                    appendArrows: $customArrows || null,
                    responsive: [ {
                        breakpoint: 767,
                        settings: "unslick"
                    } ],
                    ...options
                }), $currentSlider.find(".slick-slide").length > $currentSlider.slick("slickGetOption", "slidesToShow") && $currentSlider.closest("section").addClass("has-slider");
            }
        }));
    }, resizeObserver = new ResizeObserver((entries => {}));
    $doc.on("click", (function(e) {
        const $clickedEl = $(e.target);
        isMobile() || $clickedEl.closest(".popup__inner").length || $clickedEl.hasClass("js-toggle-menu") || ($(".js-toggle-menu").removeClass("is-active"), 
        $(".js-popup").removeClass("is-visible"), $("body").removeClass("nav-open"), $(".dropdown").removeClass("is-visible"));
    })), $doc.on("click", ".js-toggle-menu", (function(e) {
        e.preventDefault();
        const $burgetBtn = $(this);
        $($burgetBtn.attr("data-id")).toggleClass("is-visible"), $burgetBtn.toggleClass("is-active"), 
        $("body").toggleClass("nav-open"), $(".dropdown").removeClass("is-visible");
    })), $doc.on("click", ".js-close-bar", (function(e) {
        e.preventDefault();
        const $closeBarBtn = $(this), $header = $(".header"), $barToClose = $closeBarBtn.closest(".header__bar"), barToCloseHeight = $barToClose.outerHeight(), headerBottomPadding = parseInt($header.css("padding-bottom"));
        $barToClose.add($header).addClass("is-closed"), $header.css("padding-bottom", headerBottomPadding - barToCloseHeight + "px"), 
        setTimeout((() => {
            $("body").css("--header-h", `${headerHeight()}px`), $(".wrapper").addClass("header-bar-closed");
        }), 300);
    })), $doc.on("click", (function(e) {
        $(e.target).closest(".popup-locations").length && $(".popup-locations").removeClass("is-open").slideUp();
    })), $doc.on("click", ".js-toggle-locations", (function(e) {
        e.preventDefault();
        const $menuToggleBtn = $(this);
        $($menuToggleBtn.attr("data-id")).toggleClass("is-open").stop(!0, !0).slideToggle(), 
        $menuToggleBtn.toggleClass("is-active");
    }));
    let locationTimer = 0;
    $doc.on("mousemove", (function(e) {
        const $menuToggleBtn = $(e.target).closest(".js-toggle-locations");
        $($menuToggleBtn.attr("data-id"));
        $menuToggleBtn.length || $(e.target).closest(".popup-locations .popup__inner").length || !$(".popup-locations").hasClass("is-open") ? clearTimeout(locationTimer) : (clearTimeout(locationTimer), 
        locationTimer = setTimeout((function() {
            $(".popup-locations").removeClass("is-open").slideUp();
        }), 600));
    })), $doc.on("click", ".js-more-link", (function(e) {
        e.preventDefault();
        const $readMoreLink = $(this), moreText = $readMoreLink.attr("data-more-text"), lessText = $readMoreLink.attr("data-less-text"), linkText = $readMoreLink.hasClass("is-active") ? moreText : lessText;
        $readMoreLink.toggleClass("is-active"), $readMoreLink.find("span").text(linkText), 
        $readMoreLink.parent().find(".js-hidden-text").slideToggle();
    })), $doc.on("click", ".js-accordion .accordion__head", (function(e) {
        e.preventDefault();
        const $this = $(this);
        $this.toggleClass("is-active").siblings().removeClass("is-active"), $this.next().stop(!0, !0).slideToggle().closest(".accordion__section").toggleClass("is-open");
    })), $doc.on("click", ".menu-item-has-children > a", (function(e) {
        e.preventDefault();
        $(this).next().addClass("is-visible");
    })), $doc.on("click", ".js-dropdown-back", (function(e) {
        e.preventDefault(), $(this).closest(".dropdown").removeClass("is-visible");
    })), $doc.on("click", ".js-accordion-map .accordion__head", (function(e) {
        e.preventDefault();
        const $this = $(this);
        $this.toggleClass("is-active").siblings().removeClass("is-active"), $this.next().stop(!0, !0).slideToggle().closest(".accordion__section").toggleClass("is-open");
    })), $doc.on("change", 'input[type="radio"]', (function() {
        radioButtonsStep();
    })), $((function() {
        $(".js-open-popup").each((function() {
            $(this).magnificPopup({
                type: "inline",
                preloader: !1,
                modal: !0,
                fixedContentPos: !0,
                overflowY: "hidden",
                closeOnBgClick: !0,
                enableEscapeKey: !0,
                callbacks: {
                    open: function() {
                        $(".popup .slick-initialized").slick("refresh");
                    },
                    close: function() {}
                }
            });
        }));
    })), $win.on("load, scroll", (function() {
        !function performanceData(topPosition) {
            $(".js-lottie").each((function() {
                for (let element = $(this), winH = $win.height() / 1.5, i = element.length - 1; i >= 0; i--) {
                    const currentElementTop = element.eq(i).offset().top - winH;
                    if (element.hasClass("is-animate")) return;
                    topPosition > currentElementTop && (element.addClass("is-animate"), $.ajax({
                        url: element.data("anim"),
                        type: "GET",
                        beforeSend: function() {},
                        success: function(response) {
                            const params = {
                                container: element[0],
                                renderer: "svg",
                                autoplay: !0,
                                loop: !1,
                                animationData: response
                            };
                            lottie.loadAnimation(params);
                        },
                        error: function() {}
                    }));
                }
            }));
        }($win.scrollTop());
    })), $(document).on("click", ".popup-modal-dismiss", (function(e) {
        e.preventDefault(), $.magnificPopup.close();
    })), ((players, options) => {
        players.each((function() {
            if (!this) return;
            const $currentMedia = $(this).closest(".media"), mediaAutoplay = "click" !== $currentMedia.data("autoplay") && !1 !== $currentMedia.data("autoplay") && "hover" !== $currentMedia.data("autoplay"), clickToPlay = !0 === $currentMedia.data("click-to-play"), player = new Plyr(this, {
                volume: 0,
                autoplay: !1,
                clickToPlay: clickToPlay,
                controls: [],
                muted: !0,
                loop: {
                    active: !0
                },
                vimeo: {
                    background: !0
                },
                ...options
            });
            let observer = new IntersectionObserver((entries => {
                entries.map((entry => {
                    entry.isIntersecting && mediaAutoplay && player ? player.play() : player.pause();
                }));
            }), {
                rootMargin: "0px +200px",
                threshold: 0
            });
            $currentMedia[0].plyr = player, player.on("ready", (() => {
                player.muted = !0, player.volume = 0, player.decreaseVolume(100), player.pause(), 
                observer.observe($currentMedia[0]);
            })), player.on("play", (() => {
                $currentMedia.addClass("is-played");
            })), player.on("pause", (() => {
                $currentMedia.removeClass("is-played").find(".js-play-btn").removeClass("is-played");
            }));
        }));
    })(players), resizeObserver.observe($header[0]), initSlider(".js-slider-articles", {
        slidesToShow: 3,
        variableWidth: !0,
        infinite: !1,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: !1
            }
        } ]
    }), initSlider(".js-slider-articles--secondary", {
        slidesToShow: 3,
        infinite: !1,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1.37,
                slidesToScroll: 1
            }
        } ]
    }), initSlider(".js-slider-hero", {
        slidesToShow: 1,
        infinite: !0,
        variableWidth: !0,
        swipe: !0,
        draggable: !0,
        responsive: [ {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                variableWidth: !1
            }
        } ]
    }), initSlider(".js-slider-hero-dotted", {
        slidesToShow: 2,
        infinite: !1,
        swipe: !0,
        draggable: !0,
        dots: !0,
        responsive: [ {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1
            }
        } ]
    }), initSlider(".js-slider-articles-large", {
        slidesToShow: 4,
        infinite: !1,
        swipe: !0,
        variableWidth: !0,
        draggable: !0,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
                variableWidth: !1,
                slidesToShow: 1
            }
        } ]
    }), initSlider(".js-slider-large-media", {
        slidesToShow: 1,
        infinite: !1,
        variableWidth: !0,
        responsive: [ {
            breakpoint: 767,
            settings: {
                arrows: !1,
                variableWidth: !1
            }
        } ]
    }), initSlider(".js-slider-cards", {
        slidesToShow: 3,
        infinite: !1,
        variableWidth: !0,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 1023,
            settings: {
                variableWidth: !1,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    }), initSlider(".js-slider-articles-small", {
        slidesToShow: 3,
        infinite: !1,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    }), initSlider(".js-slider-reels", {
        slidesToShow: 3,
        infinite: !1,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1
            }
        } ]
    }), initSlider(".js-slider-gallery", {
        slidesToShow: 2,
        infinite: !1,
        variableWidth: !0,
        responsive: [ {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: !1
            }
        } ]
    }), initSlider(".js-slider-datepicker", {
        slidesToShow: 1,
        infinite: !1
    }), initMobileSliders(".js-slider-mobile", {
        slidesToShow: 1
    }), initSlider(".js-slider-content-image", {
        slidesToShow: 1,
        infinite: !1,
        adaptiveHeight: !0,
        asNavFor: ".js-slider-content-image-popup .slider__slides"
    }), initSlider(".js-slider-content-image-popup", {
        slidesToShow: 1,
        infinite: !1,
        adaptiveHeight: !0
    }), $(".module--contact_calendar").length > 0 && $(".module--contact_calendar").each((function() {
        const ajaxURL = $(this).attr("data-ajax-url");
        $.ajax({
            url: ajaxURL,
            dataType: "json",
            success: function(response) {
                if ("ok" == response.status && response.results.length > 0) for (i in response.results) {
                    const thisDate = response.results[i];
                    $("#calendarDate--" + thisDate).addClass("is-active");
                }
            }
        });
    })), $(".list-datepicker li a").on("click", (function() {
        return !1;
    })), setWindowHeightAsCssVariable(), setHeaderHeightAsCssVariable(), initElementParallax($parallaxContainers), 
    (() => {
        const $layers = $(".js-layer");
        if (!$layers.length) return;
        const speed = parseInt($layers.closest(".hero__layers").attr("data-layer-speed"));
        for (let i = 0; i < $layers.length; i++) setTimeout((() => {
            $layers.eq(i).addClass("is-visible");
        }), speed * i);
    })(), $window.on("load", (() => {
        setHeroHeightAsCssVariable(), setWindowHeightAsCssVariable(), setHeaderHeightAsCssVariable(), 
        handleServiceContentHeight(), setTimeout((() => {
            setHeroHeightAsCssVariable();
        }), 200), $("html").addClass("efr-loaded");
    })).on("scroll", (() => {
        initElementParallax($parallaxContainers), function toggleBreadcrumnsVisibility() {
            const $breadcrumbs = $(".breadcrumbs"), isBreadcrumbsVisible = $win.scrollTop() > heroHeight() + headerHeight();
            $breadcrumbs.toggleClass("is-hidden", isBreadcrumbsVisible);
        }();
    })).on("resize", (() => {
        setWindowHeightAsCssVariable();
    })), radioButtonsStep(), adjustSelectWidth(), $(".filters select").on("change.efr", adjustSelectWidth);
    const growArticlesContentHeight = () => {
        const $growContent = $(".grid--grow .article__content p"), contentHeights = $growContent.map(((_, height) => $(height).outerHeight())), biggestParagraph = Math.max(...contentHeights);
        $growContent.css("--content-h", `${biggestParagraph}px`);
    };
    growArticlesContentHeight(), $win.on("widthResize", (function() {
        clearTimeout(resizeTimer), setHeaderHeightAsCssVariable(), setWindowHeightAsCssVariable(), 
        growArticlesContentHeight(), handleServiceContentHeight(), setTimeout((() => {
            setHeroHeightAsCssVariable();
        }), 200), resizeTimer = setTimeout((function() {
            initMobileSliders(".js-slider-mobile", {
                slidesToShow: 1
            }), $(".js-slider-hero .slick-slider").slick("unslick"), initSlider(".js-slider-hero", {
                slidesToShow: 1,
                infinite: !0,
                variableWidth: !0,
                swipe: !0,
                draggable: !0,
                responsive: [ {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: !1
                    }
                } ]
            });
        }), 250);
    }));
    const intersectionObserver = new IntersectionObserver((entries => {
        entries.forEach((entry => {
            entry.isIntersecting && $(entry.target).addClass("is-visible");
        }));
    }), {
        threshold: 0,
        rootMargin: "+20px 0px"
    });
    document.querySelectorAll("[data-slide-up]").forEach((el => {
        intersectionObserver.observe(el);
    }));
    let currentArticlesFilters = {};
    function loadMoreArticles() {
        const observer = new IntersectionObserver(((entries, observer) => {
            entries.forEach((entry => {
                if (entry.isIntersecting) {
                    $(entry.target).trigger("click"), observer.unobserve(entry.target);
                }
            }));
        }), {
            threshold: 1
        });
        function observeLoadMoreButtons() {
            $(".js-load-more").each((function() {
                observer.observe(this);
            }));
        }
        observeLoadMoreButtons(), $(".js-load-more").on("click", (function(e) {
            if (e.preventDefault(), e.stopPropagation(), $.active > 0) return;
            let $button = $(this), $ajaxContainer = $button.parent(), elementsContainerClass = $button.data("load-more-container"), $elementsContainer = $(elementsContainerClass), nextPage = $button.data("paged"), maxPage = $button.data("max"), target = $button.data("item");
            if (void 0 === maxPage) return;
            let requestData = {
                crb_paged: nextPage,
                efront_filters: currentArticlesFilters
            };
            $.ajax({
                url: window.location.href,
                type: "GET",
                data: requestData,
                beforeSend: function() {
                    $("body").addClass("loading");
                },
                success: function(response) {
                    if ($(response).find(elementsContainerClass).find(target).appendTo($elementsContainer), 
                    document.querySelectorAll("[data-slide-up]").forEach((el => {
                        intersectionObserver.observe(el);
                    })), $(response).find("[data-load-more]").length) {
                        const newRequestUrl = $(response).find("[data-load-more]").attr("href");
                        $button.attr("href", newRequestUrl), $button.data("paged", nextPage + 1);
                    } else $button.remove();
                    observeLoadMoreButtons();
                },
                error: function() {
                    $ajaxContainer.html("<h3>Error has occurred, please try again!</h3>");
                },
                complete: function() {
                    $("body").removeClass("loading");
                }
            });
        }));
    }
    $(".js-article-filters").on("change", (function() {
        const tax = $(".js-type-tax").children("option:selected").val(), sort = $(".js-type-sort").children("option:selected").val();
        currentArticlesFilters.article_tax = tax, currentArticlesFilters.article_sort = sort, 
        $.ajax({
            url: window.location.href,
            type: "GET",
            data: {
                efront_filters: currentArticlesFilters
            },
            beforeSend: function() {
                $body.addClass("loading");
            },
            success: function(response) {
                const $newItems = $(response).find(".js-filtered-articles").html();
                $(".js-filtered-articles").html($newItems), loadMoreArticles(), document.querySelectorAll("[data-slide-up]").forEach((el => {
                    intersectionObserver.observe(el);
                }));
            },
            error: function(jqXHR) {
                console.log(jqXHR);
            },
            complete: function() {
                $body.removeClass("loading");
            }
        });
    })), loadMoreArticles(), $(".js-university-filters").on("change", (function() {
        const loc = $(".js-university-filters").children("option:selected").val();
        $.ajax({
            url: window.location.href,
            type: "GET",
            data: {
                efront_uni_filter: loc
            },
            beforeSend: function() {
                $body.addClass("loading");
            },
            success: function(response) {
                const $newItems = $(response).find(".js-filtered-unis").html(), $newItemsArrows = $(response).find(".js-filtered-unis-slider-arrows").html();
                $(".js-filtered-unis").html($newItems), $(".js-filtered-unis-slider-arrows").html($newItemsArrows), 
                initSlider(".js-slider-articles", {
                    slidesToShow: 3,
                    variableWidth: !0,
                    infinite: !1,
                    responsive: [ {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: !1
                        }
                    } ]
                }), document.querySelectorAll("[data-slide-up]").forEach((el => {
                    intersectionObserver.observe(el);
                }));
            },
            error: function(jqXHR) {
                console.log(jqXHR);
            },
            complete: function() {
                $body.removeClass("loading");
            }
        });
    })), $(".js-header-cta-cookie").on("click", (function() {
        document.cookie = "cta_clicked=true; path=/; max-age=3600";
    })), $(".js-click-parent").each((function(e) {
        const $innerLink = $(this).find(".js-click-element");
        this.onclick = function(evnt) {
            if (evnt.ctrlKey || evnt.shiftKey || evnt.metaKey || evnt.button && 1 == evnt.button) {
                const href = $innerLink.attr("href");
                window.open(href);
            } else $innerLink[0].click();
        };
    })), $(document).on("gform_confirmation_loaded", (function(e, form_id) {
        $(".gform_confirmation_wrapper").closest(".form").addClass("form--success");
    }));
}(jQuery, window, document);